// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/hero-banner/hero-banner.component.scss
// module id = 73
// module chunks = 0